import React, { Component } from "react";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import { Row } from "react-flexbox-grid";
import NumericInput from "react-numeric-input";

import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";

import httpr from "lib/httpRequest";

const styles = (theme) => ({
  formControl: {
    width: "100%",
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class ThresholdForm extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      terminals: [],
      terminalTypes: [],
      cassettes: [],
      denominations: [],
      selectedRecyclers: [],
      initialEditSetup: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    // if terminals have been selected AND if the selected terminals have changed, fetch new cassettes
    if (this.props.selectedTerminals.length > 0) {
      if (prevProps.selectedTerminals !== this.props.selectedTerminals) {
        if (this.props.selectedTerminals.includes("All")) {
          // IF ALL TERMS SELECTED
          // add all terminal objects selected to an array
          let temp = [];
          // get ALL terminals from selected location
          this.props.terminals.map((terminal, index) => {
            if (
              terminal.location.LocationId === this.props.selectedLocationId
            ) {
              // these are the terminals you need to check
              temp.push(this.props.terminals[index]);
            }
          });

          // add types to an array
          let types = [];
          temp.map((terminal) => {
            types.push(terminal.RECYCLER_TYPE_ID);
          });

          // fetch cassettes
          this.getCassettes(types, this.props.selectedLocationId);
        } else {
          // IF SPECIFIC TERMS SELECTED
          // add all terminal objects selected to an array
          let temp = [];
          this.props.selectedTerminals.map((id) => {
            temp.push(this.props.terminals[id]);
          });

          // add types to an array
          let types = [];
          temp.map((terminal) => {
            types.push(terminal.RECYCLER_TYPE_ID);
          });
          // fetch cassettes
          this.getCassettes(types, this.props.selectedLocationId);
        }
      }
    }

    // if selected cassettes have changed AND selected cassettes is not zero
    // AND All cassettes are selected
    if (
      prevProps.selectedCassettes !== this.props.selectedCassettes ||
      prevState.cassettes !== this.state.cassettes
    ) {
      let coinCassetteList = [];
      let cashCassetteList = [];
      if (
        this.props.selectedCassettes.length > 0 &&
        this.props.selectedCassettes.includes("All")
      ) {
        // IF ALL CASSETTES SELECTED
        if (this.state.cassettes.length > 0) {
          // get all cassettes
          this.state.cassettes.map((cassette) => {
            if (cassette.CASH_TYPE === "Coin") {
              let n = cassette.UNIT_ID;
              n = `'${n}'`;
              coinCassetteList.push(n);
            } else if (cassette.CASH_TYPE === "Cash") {
              let n = cassette.UNIT_ID;
              n = `'${n}'`;
              cashCassetteList.push(n);
            }
          });
        } else {
          // this is the first update after a location is selected.  No cassettes have been fetched.
          coinCassetteList.push("first load");
          cashCassetteList.push("first load");
        }
      } else {
        // IF CASSETTES SPECIFIED
        // get List of cassettes from provided indexes
        this.props.selectedCassettes.map((i) => {
          if (this.state.cassettes[i].CASH_TYPE === "Coin") {
            let n = this.state.cassettes[i].UNIT_ID;
            n = `'${n}'`;
            coinCassetteList.push(n);
          } else if (this.state.cassettes[i].CASH_TYPE === "Cash") {
            let n = this.state.cassettes[i].UNIT_ID;
            n = `'${n}'`;
            cashCassetteList.push(n);
          }
        });
      }

      // fetch denoms
      this.getDenominations(
        coinCassetteList,
        cashCassetteList,
        this.props.selectedLocationId
      );
    }

    // if in edit form AND cassettes have been fetched AND selected cassettes have changed
    if (
      this.props.edit &&
      this.props.editSetupCass &&
      this.state.cassettes.length > 0
    ) {
      this.props.prePopCassettes(this.state.cassettes);
    }

    if (
      this.props.edit &&
      this.props.editSetupDen &&
      this.state.denominations.length > 0
    ) {
      this.props.prePopDenoms(this.state.denominations);
    }
  }

  /* FETCH FUNCTIONS */
  getCassettes = (terminalTypes, selectedLocationId) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .post("/api/terminal/cassettes/", {
        terminalTypes: terminalTypes,
        selectedLocationId: selectedLocationId,
      })
      .then((response) => {
        if (this._isMounted === true) {
          this.setState({
            cassettes: response.data.cassetteDetails,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getDenominations = (
    coinCassetteList,
    cashCassetteList,
    selectedLocationId
  ) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .post("/api/terminal/denominations/", {
        coinCassetteList: coinCassetteList,
        cashCassetteList: cashCassetteList,
        selectedLocationId: selectedLocationId,
      })
      .then((response) => {
        let allDenoms = response.data.cashDenoms.concat(
          response.data.coinDenoms
        );
        if (this._isMounted === true) {
          this.setState({
            denominations: allDenoms,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /* SELECT DROPDOWN RENDER FUNCTIONS */
  renderSelectedCassettes = (event) => {
    const { cassettes } = this.state;
    if (cassettes.length !== 0 && event.includes("All")) {
      return "All";
    }
    // if multiple
    if (event.length > 1 && cassettes.length > 0) {
      let list = [];
      let cassette;
      event.map((cassetteIndex) => {
        cassette = cassettes[cassetteIndex];
        list.push(cassette.UNIT_ID);
      });
      return `${list.join(", ")}`;
    } else {
      // if only one selected:
      if (cassettes[event]) {
        const cassette = cassettes[event];
        return `${cassette.UNIT_ID}`;
      }
    }
  };

  renderSelectedDenominations = (event) => {
    const { denominations } = this.state;
    if (this.state.cassettes.length !== 0 && event.includes("All")) {
      return "All";
    }
    // if multiple
    if (event.length > 1) {
      let list = [];
      let denom;
      event.map((denomIndex) => {
        denom = denominations[denomIndex];
        list.push(denom.NOTE_VALUE);
      });
      return `${list.join(", ")}`;
    } else {
      // if only one selected:
      if (denominations[event]) {
        const denom = denominations[event];
        return `${denom.NOTE_VALUE}`;
      }
    }
  };

  render() {
    const {
      selectedCassettes,
      selectedDenominations,
      minThreshold,
      maxThreshold,
      classes,
    } = this.props;

    const { cassettes, denominations } = this.state;

    /* SELECT LISTS */
    let allCassettes;
    if (cassettes.length === 0) {
      allCassettes = (
        <MenuItem key={0} value={0} disabled>
          <ListItemText primary={"Please select terminals first"} />
        </MenuItem>
      );
    } else {
      allCassettes = cassettes.map((cassette, index) => {
        return (
          <MenuItem key={index} value={index}>
            <Checkbox
              checked={this.props.selectedCassettes.indexOf(index) > -1}
            />
            <ListItemText
              primary={`${cassette.UNIT_ID} - ${cassette.CASH_TYPE}`}
            />
          </MenuItem>
        );
      });
    }

    let allDenominations;
    if (cassettes.length === 0) {
      allDenominations = (
        <MenuItem key={0} value={0} disabled>
          <ListItemText primary={"Please select cassettes first"} />
        </MenuItem>
      );
    } else {
      allDenominations = denominations.map((denom, index) => {
        return (
          <MenuItem key={index} value={index}>
            <Checkbox
              checked={this.props.selectedDenominations.indexOf(index) > -1}
            />
            <ListItemText primary={`${denom.UNIT_ID} - ${denom.NOTE_VALUE}`} />
          </MenuItem>
        );
      });
    }

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="select-multiple-checkbox">
                Select Cassettes
              </InputLabel>
              <Select
                name="selectedCassettes"
                multiple={true}
                value={selectedCassettes}
                onChange={this.props.handleSelectedCassettes(cassettes)}
                input={<Input id="select-multiple-checkbox" />}
                renderValue={this.renderSelectedCassettes}
                MenuProps={MenuProps}
              >
                {this.props.selectedTerminals.length > 0 &&
                  cassettes.length !== 0 && (
                    <MenuItem value={"All"}>
                      <Checkbox checked={this.props.allCassettesSelected} />
                      <ListItemText primary={"All"} />
                    </MenuItem>
                  )}
                {allCassettes}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="select-multiple-checkbox">
                Select Denominations
              </InputLabel>
              <Select
                name="selectedDenominations"
                multiple={true}
                value={selectedDenominations}
                input={<Input id="select-multiple-checkbox" />}
                onChange={this.props.handleDenominationsSelected(denominations)}
                renderValue={this.renderSelectedDenominations}
                MenuProps={MenuProps}
              >
                {this.props.selectedCassettes.length > 0 &&
                  denominations.length !== 0 && (
                    <MenuItem value={"All"}>
                      <Checkbox checked={this.props.allDenomsSelected} />
                      <ListItemText primary={"All"} />
                    </MenuItem>
                  )}
                {allDenominations}
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Row center="xs">
              <InputLabel>Set Minimum Threshold</InputLabel>
            </Row>
            <NumericInput
              mobile
              className={classes.formControl}
              min={0}
              max={3000}
              size={100}
              step={10}
              value={minThreshold}
              onChange={this.props.handleMinThresholdChanged}
              style={{
                width: "100%",
                wrap: {
                  marginBottom: "10px",
                },
                input: {
                  display: "block",
                  fontWeight: 100,
                  width: "100%",
                  height: "35px",
                },
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Row center="xs">
              <InputLabel>Set Maximum Threshold</InputLabel>
            </Row>
            <NumericInput
              mobile
              className={styles.formControl}
              min={0}
              max={3000}
              size={100}
              step={10}
              value={maxThreshold}
              onChange={this.props.handleMaxThresholdChanged}
              style={{
                width: "100%",
                wrap: {
                  marginBottom: "10px",
                },
                input: {
                  display: "block",
                  fontWeight: 100,
                  width: "100%",
                  height: "35px",
                },
              }}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}
export default ThresholdForm;



// WEBPACK FOOTER //
// ./src/components/Alerts/ThresholdForm.jsx